import {useStoreService} from '../../service/store/index'
import { useEffect, useState } from 'react';


const useGetUsersRelated = (id: string) => {
    const {getAllUsersRelated} = useStoreService()
    const [choices, setChoices] = useState<any>();
    const [chosen, setChosen] = useState<any>();
    const [error, setError] = useState<any>()
    const [isLoading, setIsLoading] = useState<Boolean>(false)
  useEffect(() => {
    setIsLoading(true)
  const fetchData = async () => {
    try {
      const response = await getAllUsersRelated(parseInt(id,10));
      setChosen(response.data.chosen);
      setChoices(response.data.choices)
    } catch (err) {
      setError(err);
    }
    finally {
      setIsLoading(false)
    }
  };
  fetchData();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  return {
    choices,
    chosen,
    error,
    isLoading
  };
};

export default useGetUsersRelated;
